import { BADGE_CATEGORY } from "@shared/models";

/**
 * Display wording for each `BADGE_CATEGORY`. `BadgesSection`'s flat grid has no per-category heading
 * and does not import this module. Two consumers read it:
 *
 * - `BadgeOverlayDetailsContainer` (detail overlay) — a user clicking a Core Values badge shouldn't
 *   see "Value" once the overlay opens.
 * - `buildCategorySummaries` (the dedicated Badges screen) — each category card's heading and each
 *   filter chip's label, which is the same wording a user would have seen on the old per-category
 *   heading.
 *
 * Keyed by the enum, so a lookup is only total for a category this build's `BADGE_CATEGORY` knows
 * about; see `buildCategorySummaries`' own `categoryLabel` for what happens to a value the api sends
 * that this build does not have.
 */
export const CATEGORY_LABELS: Record<BADGE_CATEGORY, string> = {
  [BADGE_CATEGORY.FLAME]: "Flame",
  [BADGE_CATEGORY.VALUE]: "Core Values",
  [BADGE_CATEGORY.ACHIEVEMENT]: "Achievements",
  [BADGE_CATEGORY.TENURE]: "Tenure",
  [BADGE_CATEGORY.SEASONAL]: "Seasonal",
};
